export const setCookie = (key, value, duration, domain) => {
    let expires = "; expires=Mon, 30 Dec 2030 16:00:00 GMT";
    if (duration) {
        const date = new Date();
        date.setSeconds(duration);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${key}=${value || ""}${expires}; path=/; ${domain ? `domain=${domain}` : ""}`;
};
export const getCookie = (key) => {
    return (document.cookie
        .split("; ")
        .find((el) => el.startsWith(key))
        ?.split("=")[1] || "");
};
export const deleteCookie = (key, domain) => {
    let d;
    if (domain) {
        d = window.location.hostname.substring(window.location.hostname.indexOf(".") + 1);
    }
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; ${d ? `domain=${d}` : ""}`;
};
